// Import required dependencies from React, Material-UI, and react-icons
import React, { useState } from 'react';
import { IconButton, Popover, Typography } from '@mui/material';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import { useTheme } from '@mui/material/styles';
import interfaceHelpText from '../utils/interfaceHelpText';

// HelpInfoIcon component to display a help icon with a popover containing contextual help text
function HelpInfoIcon({ page }) {
  // State to manage the popover's anchor element
  const [anchorEl, setAnchorEl] = useState(null);
  // Access Material-UI theme for consistent styling
  const theme = useTheme();

  // Open the popover by setting the anchor element
  const handleClick = (event) => setAnchorEl(event.currentTarget);

  // Close the popover by clearing the anchor element
  const handleClose = () => setAnchorEl(null);

  // Determine if the popover is open
  const open = Boolean(anchorEl);
  // Generate a unique ID for the popover when open
  const id = open ? `${page}-help-popover` : undefined;

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-describedby={id}
        sx={{
          position: 'absolute',
          top: 22,
          right: 16,
          color: theme.palette.mode === 'light' ? '#1b2a41' : '#ffffff',
          transition: 'color 0.2s ease',
          '&:hover': {
            color:
              theme.palette.mode === 'light'
                ? theme.palette.primary.light
                : theme.palette.primary.main,
          },
        }}
      >
        {/* Render the info icon */}
        <BsFillInfoCircleFill size={22} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            borderRadius: 2.5,
            maxWidth: 320,
            backgroundColor: theme.palette.background.paper,
          },
        }}
      >
        {/* Display help text for the specified page or a fallback message */}
        <Typography sx={{ p: 2, color: theme.palette.text.primary }}>
          {interfaceHelpText[page] || 'No help text available.'}
        </Typography>
      </Popover>
    </>
  );
}

// Export the component as default
export default HelpInfoIcon;